import 'promise-polyfill/lib/polyfill';
import ShopifyCartProvider from './providers/ShopifyCartProvider';

export default class CartService {
  constructor(type) {
    this._provider = null;
    switch (type.toLowerCase()) {
      case 'shopify': {
        this._provider = ShopifyCartProvider;
        break;
      }
      default:
        this._provider = ShopifyCartProvider;
    }
  }

  getShippingRates(zip, country, province) {
    return this._provider.getShippingRates(zip, country, province);
  }

  updateCart(data, endpoint) {
    return this._provider.updateCart(data, endpoint);
  }

  getCart() {
    return this._provider.getCart();
  }

  addItem(id, quantity, properties = {}) {
    return this._provider.addItem(id, quantity, properties);
  }

  reload() {
    return this._provider.reload();
  }

  clearCart() {
    return this._provider.clearCart();
  }

  updateNote(note) {
    return this._provider.updateNote(note);
  }

  updateAttributes(attributes) {
    return this._provider.updateAttributes(attributes);
  }

  updateQuantity(key, quantity) {
    return this._provider.updateQuantity(key, quantity);
  }
}
